import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastNotification = () => {
  const toastState = useSelector((state) => state.toast || {});
  const { message, type } = toastState;

  useEffect(() => {
    if (message) {
      if (type === "error") {
        toast.error(message);
      } else {
        toast.success(message);
      }
    }
  }, [message, type]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

export default ToastNotification;
